import type { UseFormReturn } from "react-hook-form";
import { useTranslation } from "react-i18next";
import type { ThemeClasses } from "../types";
import type { Unit } from "../../../../../../store/admin/unitsStore";
import Modal from "../../../../../../components/base/Modal";
import {
  TrackingLinkForm,
  type TrackingLinkFormData,
} from "./TrackingLinkForm";

interface TrackingLinkModalProps {
  isOpen: boolean;
  isEdit: boolean;
  loadingSubmit: boolean;
  form: UseFormReturn<TrackingLinkFormData>;
  themeClasses: ThemeClasses;
  isDarkMode: boolean;
  units: Unit[];
  onSubmit: (data: TrackingLinkFormData) => void;
  onClose: () => void;
}

export function TrackingLinkModal({
  isOpen,
  isEdit,
  loadingSubmit,
  form,
  themeClasses,
  isDarkMode,
  units,
  onSubmit,
  onClose,
}: TrackingLinkModalProps) {
  const { t } = useTranslation("adminSections");
  
  if (!isOpen) return null;

  return (
    <Modal
      title={isEdit ? t("trackingLinks.modal.editTitle") : t("trackingLinks.modal.createTitle")}
      onClose={onClose}
      themeClasses={themeClasses}
      width="w-[650px] max-w-full"
      content={
        <TrackingLinkForm
          form={form}
          isEdit={isEdit}
          loadingSubmit={loadingSubmit}
          themeClasses={themeClasses}
          isDarkMode={isDarkMode}
          units={units}
          onSubmit={onSubmit}
          onCancel={onClose}
        />
      }
    />
  );
}
